import _ from "lodash";
let imgPath = process.env.PUBLIC_URL + "assets/media/screenshots/";
const ScreenshotRepo = {
  carouselImages: _.range(1, 9).map((id) => ({
    id,
    img: `${imgPath}${id}.png`,
  })),
};
export default ScreenshotRepo;
